import url from './url.js'
import axios from './axios.conf.js'
import * as mock from './mock'
import { redirectToError } from '@/public/redirectTo'
import { Toast } from 'mint-ui';

let ISMOCK = false
// ISMOCK = true

if (window.location.hostname === 'm.jd.jr.com') {
  ISMOCK = false
}

// 建新团接口
export async function buildTeam (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.buildTeam, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.buildTeam.resultData
      console.warn(url.buildTeam + ' is mocked.')
    }
  }

  if (resultData.code !== '10014zt' && resultData.code !== '00000zt') {
    redirectToError(resultData.msg, resultData.code)
  }
  return getTeamInfo(resultData)
}
export async function buildTeamWithoutRedirect (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.buildTeam, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.buildTeam.resultData
      console.warn(url.buildTeam + ' is mocked.')
    }
  }


  if (resultData.code !== '00000zt' && resultData.code !== '10014zt') {
    Toast({
      message: resultData.msg,
      position: 'top',
      duration: 2000
    })
    return
  }

  return getTeamInfo(resultData)
}
function getTeamInfo (resultData) {
  let {
    actCode,
    markId,
    actChannel,
    pin
  } = resultData.data

  let teamInfo = {
    source: actChannel,
    actCode,
    markId,
    pin,
  }
  // console.log('teamInfo', teamInfo)
  return teamInfo
}

// 参团
export async function joinBuildTeam (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.joinBuildTeam, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.joinBuildTeam.resultData
      console.warn(url.joinBuildTeam + ' is mocked.')
    }
  }

  if (resultData.code !== '00000zt' && resultData.code !== '10006zt' && resultData.code !== '10008zt' && resultData.code !== '10015zt') {
    redirectToError(resultData.msg, resultData.code)
  }
  return resultData
}

// 判断角色是否是团长
export async function isBuilder (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.isBuilder, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.isBuilder.resultData
      console.warn(url.isBuilder + ' is mocked.')
    }
  }

  if (resultData.code !== '00000zt') {
    redirectToError(resultData.msg, resultData.code)
  }
  return resultData
}

// 获取头像排行榜接口
export async function getJoinList (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.getJoinList, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.getJoinList.resultData
      console.warn(url.getJoinList + ' is mocked.')
    }
  }

  let {
    code,
    msg,
    data = []
  } = resultData

  if (code !== '00000zt') {
    redirectToError(msg, code)
  }
  let result = data.map(item => {
    let { ext = {} } = item
    if (typeof ext === 'string') {
      ext = JSON.parse(ext)
    }
    delete item.ext

    return {
      ...item,
      ...ext,
    }
  })
  // console.log('getJoinList', result)
  return result
}

//获取团长等信息
export async function getTeamLeaderInfo (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.getTeamLeaderInfo, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.getTeamLeaderInfo.resultData
      console.warn(url.getTeamLeaderInfo + ' is mocked.')
    }
  }

  if (resultData.code !== '00000zt') {
    redirectToError(resultData.msg, resultData.code)
  }

  let { ext = {} } = resultData.data || {}
  if (typeof ext === 'string') {
    ext = JSON.parse(ext)
  }

  let result = {
    ...resultData.data,
    ...ext,
  }
  delete result.ext

  return result
}

//是否还可以创建团
export async function isBuildTeam (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.isBuildTeam, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.isBuildTeam.resultData
      console.warn(url.isBuildTeam + ' is mocked.')
    }
  }

  if (resultData.code !== '00000zt' && resultData.code !== '10014zt' && resultData.code !== '10007zt') {
    redirectToError(resultData.msg, resultData.code)
  }

  return resultData
}

// 是否是团成员接口
export async function isUserBeloneTeam (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.isUserBeloneTeam, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.isUserBeloneTeam.resultData
      console.warn(url.isUserBeloneTeam + ' is mocked.')
    }
  }

  let {
    code,
    msg,
  } = resultData

  if (code !== '00000zt' && code !== '10016zt') {
    redirectToError(msg, code)
  }

  return resultData
}

//获取参与并激活列表接口(奖券)
export async function getCouponList (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.getCouponList, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.getCouponList.resultData
      console.warn(url.getCouponList + ' is mocked.')
    }
  }

  let {
    code,
    msg,
    data = []
  } = resultData

  if (code !== '00000zt') {
    redirectToError(msg, code)
  }

  let result = data.map(item => {
    let {ext = {}} = item
    if (typeof ext === 'string') {
      ext = JSON.parse(ext)
    }
    delete item.ext

    return {
      ...item,
      ...ext,
      rewardName: (item.rewardName || '').toString().split(/[;|；]/),
      rewardURL: (ext.rewardURL || '').toString().split(/[;|；]/),
    }
  })

  return result
}

// 手气排行榜
export async function getLuckyRankingList (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.getLuckyRankingList, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.getLuckyRankingList.resultData
      console.warn(url.getLuckyRankingList + ' is mocked.')
    }
  }

  let {
    code,
    msg,
    data = []
  } = resultData

  if (code !== '00') {
    redirectToError(msg, code)
  }

  let result = data.map(item => {
    let {extParam} = item
    let temp = {
      ...item,
      ...extParam,
    }
    delete temp.extParam

    return temp
  })

  return result
}

//领奖
export async function sendReward (params) {
  let resultData = {}
  try {
    resultData = await axios.post(url.sendReward, params)
  } catch (e) {

  } finally {
    if (ISMOCK) {
      let mock = await import('./mock.js')
      resultData = mock.sendReward.resultData
      console.warn(url.sendReward + ' is mocked.')
    }
  }

  return resultData
}



// WEBPACK FOOTER //
// ./src/api/index.js